import { memo } from 'react'
import useAmap from '../../../../hooks/use-amap/use-geojson'

const MapGeo = () => {
  useAmap('viewmap')
  return <div id="viewmap" className="w-full h-full" />
}

export default memo(MapGeo)
